import type { TOC } from '@ember/component/template-only';
import { eq } from 'ember-truth-helpers';

import type {
  IconColor,
  IconName,
} from '../../../../types/components/prism/icon.ts';
import type { CustomEmberTableColumn } from '../../../../types/components/prism/table.ts';
import PrismIcon from '../../icon.gts';

interface PrismTableCellsTdIconSignature {
  Args: {
    cellData: {
      iconColor: IconColor;
      iconName: IconName;
    };
    column: CustomEmberTableColumn;
  };
}

const PrismTableCellsTdIcon = <template>
  <div
    class="prism-table-td-icon
      {{if (eq @column.textAlign 'center') 'prism-table-td-icon--center'}}
      {{if (eq @column.textAlign 'right') 'prism-table-td-icon--right'}}"
  >
    <PrismIcon
      @color={{@cellData.iconColor}}
      @name={{@cellData.iconName}}
      @size="small"
    />
  </div>
</template> satisfies TOC<PrismTableCellsTdIconSignature>;

export default PrismTableCellsTdIcon;
